"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PulldownMenuItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const pulldown_menu_item_style_1 = __importDefault(require("./pulldown.menu.item.style"));
class PulldownMenuItem extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, children, onClick, icon } = this.props;
            const rootProps = {
                role: 'none',
                className: classes.root
            };
            const buttonProps = {
                type: 'button',
                role: 'menuitem',
                onClick,
                className: classes.button
            };
            return (jsx_runtime_1.jsx("li", Object.assign({}, rootProps, { children: jsx_runtime_1.jsxs("button", Object.assign({}, buttonProps, { children: [icon && jsx_runtime_1.jsx("span", Object.assign({ className: classes.buttonIcon }, { children: icon }), void 0),
                        jsx_runtime_1.jsx("span", Object.assign({ className: classes.buttonLabel }, { children: children }), void 0)] }), void 0) }), void 0));
        };
    }
}
exports.PulldownMenuItem = PulldownMenuItem;
PulldownMenuItem.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.string.isRequired,
    onClick: prop_types_1.default.func.isRequired,
    icon: prop_types_1.default.object
};
PulldownMenuItem.defaultProps = {
    icon: null
};
exports.default = react_jss_1.default(pulldown_menu_item_style_1.default)(PulldownMenuItem);
//# sourceMappingURL=pulldown.menu.item.js.map